/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.inappropriateContentModule', ['ui.router', 'bulbApp.authModule', 'bulbApp.configModule', 'bulbApp.unitModule']);
